// ITP Section (Inspection Test) - Test for station details
export const FETCH_TEST_TYPES = '@@station/list-test-types';
export const SET_TEST_TYPES = '@@station/set-test-types';
export const FETCH_TEST_TYPES_FAILURE = '@@station/set-test-types-failure';

export const FETCH_STATION_NAME = '@@station/list-station-names';
export const SET_STATION_NAME = '@@station/set-station-names';
export const FETCH_STATION_NAME_FAILURE = '@@station/set-station-names-failure';

export const ADD_TEST_DETAILS = '@@station/add-test-details';
export const ADD_TEST_DETAILS_SUCCESS = '@@station/add-test-details-success';
export const ADD_TEST_DETAILS_FAILURE = '@@station/add-test-details-failure';

export const FETCH_STATION_TEST_DETAILS = '@@station/fetch-station-test-details';
export const FETCH_STATION_TEST_DETAILS_SUCCESS = '@@station/fetch-station-test-details-success';
export const FETCH_STATION_TEST_DETAILS_FAILURE = '@@station/fetch-station-test-details-failure';

export const DELETE_TEST_DETAILS = '@@test/delete-test-details';
export const UPDATE_TEST_DETAILS = '@@test/update-test-details';

//
export const UPLOAD_ITPADDSTATION_FILE = '@@sow/upload-itp-add-station-File';
export const UPLOAD_ITPADDSTATION_FILE_SUCCESS = '@@sow/upload-itp-add-station-File-success';
export const UPLOAD_ITPADDSTATION_FILE_FAILURE = '@@sow/upload-itp-add-station-File-failure';
